export default __webpack_public_path__ + "static/media/home-decor-img-12.55776b63.jpg";